import { PropsWithChildren } from "react";

import { View } from "react-native";
import { Icon, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import TextInputHelperText from "../TextInputHelperText";

type Props = PropsWithChildren<{
  label: string;
  icon?: string;
  required?: boolean;
  info?: string | React.ReactNode;
  error?: string | React.ReactNode;
  hidden?: boolean;
}>;

export default function FormField({
  label,
  icon,
  required,
  info,
  error,
  hidden,
  children,
}: Props) {
  const tailwind = useTailwind();
  const text = required ? `${label} *` : label;
  const showHelper = required || info || error;

  if (hidden) return null;

  return (
    <View>
      <View style={tailwind("flex-row items-center gap-1 mb-2")}>
        {icon && <Icon source={icon} size={20} />}
        <Text variant="labelLarge">{text}</Text>
      </View>
      {children}
      {showHelper && <TextInputHelperText info={info} error={error} />}
    </View>
  );
}
